import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import AboutSection from './components/AboutSection';
import TestimonialsFAQ from './components/TestimonialsFAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { categories } from '@/mocks/categories';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: 'What is Hipobuy Spreadsheet?', acceptedAnswer: { '@type': 'Answer', text: 'Hipobuy Spreadsheet is a comprehensive product research system that organizes thousands of products into categorized lists for easy discovery.' } },
      { '@type': 'Question', name: 'Is Hipobuy Spreadsheet free to use?', acceptedAnswer: { '@type': 'Answer', text: 'Yes, Hipobuy Spreadsheet resources are completely free to access without any subscription required.' } },
      { '@type': 'Question', name: 'How often is the Hipobuy Spreadsheet updated?', acceptedAnswer: { '@type': 'Answer', text: 'The product database is updated regularly to ensure access to the latest products and information across all categories.' } },
    ],
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hipobuy Spreadsheet',
    url: siteUrl,
    logo: `${siteUrl}/favicon.jpeg`,
    image: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
    description: 'The ultimate Hipobuy Spreadsheet resource hub for product research and category discovery.',
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}></script>
      <Navbar />
      <main>
        <Hero />

        <section className="bg-background-50 py-10 md:py-14">
          <div className="w-full px-4 md:px-10 max-w-[1280px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                Browse <span className="text-accent-600">Product Categories</span>
              </h2>
              <p className="mt-2 text-foreground-500 text-sm">
                Select a category to explore products on our main website
              </p>
            </div>
            <CategoryDropdown />

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 max-w-4xl mx-auto">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center justify-center px-3 py-2.5 bg-background-100 hover:bg-accent-50 border border-background-200 hover:border-accent-200 rounded-lg text-foreground-700 hover:text-accent-700 text-xs font-medium transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </section>

        <CategoryGrid />
        <FeatureGrid />
        <AboutSection />
        <TestimonialsFAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}